<template>
  <material-card
:title="$t('globals.drugs')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="supervised_user_circle"
  >
    <v-card-text class="content">
      <v-stepper
        non-linear
        v-model="step"
        vertical
        class="elevation-0"
        style="width: 100%;"
      >
        <v-stepper-step :complete="step > 1" step="1" :editable="step <= 2">
          {{ $t("components.drugs.drugsimport.download_template") }}
          <small>
            {{ $t("components.drugs.drugsimport.download_and_use") }}
          </small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-container>
            <div class="row">
              <div class="col-12 col-md-12">
                <v-btn
                  color="success"
                  class="ma-1"
                  @click="downloadAll"
                  :loading="downloadingAll"
                >
                  {{ $t("components.drugs.drugsimport.all_drugs") }}
                </v-btn>
                <v-btn
                  color="success"
                  class="ma-1"
                  @click="downloadEmpty"
                  :loading="downloadingEmpty"
                >
                  {{ $t("components.membersimportwizardcomponent.empty") }}
                </v-btn>
                <v-btn color="primary" class="ma-1" @click="step++">
                  {{ $t("globals.continue") }}
                </v-btn>
              </div>
            </div>
          </v-container>
        </v-stepper-content>

        <v-stepper-step :complete="step > 2" step="2" editable>
          {{ $t("components.drugs.drugsimport.import_replace") }}
          <small>
            {{ $t("components.drugs.drugsimport.choose_the_file") }}
          </small>
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-form :disabled="loading" ref="form">
            <v-container>
              <div class="row">
                <div class="col-12 col-md-8">
                  <v-file-input v-model="file"></v-file-input>
                </div>
                <div class="col-12 col-md-4">
                  <v-btn
                    color="primary"
                    :disabled="!file"
                    :loading="loading"
                    @click="upload"
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </div>
              </div>
            </v-container>
          </v-form>
          <v-alert
            v-for="(error, i) in errors"
            dense
            type="error"
            :key="i"
            dismissible
          >
            {{ $t(error) }}
          </v-alert>
        </v-stepper-content>
      </v-stepper>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text :loading="loading" @click="$emit('cancel')">
        {{ $t("globals.close") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Downloader, ExcelData } from "pbas-vue-components";
import DrugHeaders from "../../headers/NewDrugs";
import ErrorHandler from "../../components/ErrorHandler";

export default {
  components: { ErrorHandler },
  props: {
    provider: Object,
    planId: String
  },
  data: function() {
    return {
      file: null,
      loading: false,
      error: null,
      step: 1,
      downloadingEmpty: false,
      downloadingAll: false,
      errors: [],
    };
  },
  mounted() {
    this.step = 1;
    this.file = null;
  },
  computed: {
    ...mapGetters("common", { settings: "settings" }),
  },
  methods: {
    ...mapActions("claims", ["importDrugs"]),
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async downloadEmpty() {
      this.downloadingEmpty = true;
      try {
        const blob = await this.$exporters[1].exportData(
          this.provider,
          { items: [] },
          DrugHeaders.slice(1, 4)
        );
        new Downloader().download("drugs-template.xlsx", blob);
      } catch (e) {
        this.error = e;
      } finally {
        this.downloadingEmpty = false;
      }
    },
    async downloadAll() {
      this.downloadingAll = true;
      try {
        const items = await this.provider.dataProvider.fetchAsync();
        const blob = await this.$exporters[1].exportData(
          this.provider,
          { items: items.items },
          DrugHeaders.slice(1, 5)
        );
        new Downloader().download("drugs.xlsx", blob);
      } catch (e) {
        this.error = e;
      } finally {
        this.downloadingAll = false;
      }
    },
    async upload() {
      try {
        const data = await this.toBase64(this.file);
        await this.withLoad(
          this.importDrugs({
            base64: data,
            name: this.file.name,
            planId: this.planId,
          })
        );
        this.$emit("upload");
      } catch (error) {
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 2900
        ) {
          const errors = JSON.parse(error.response.data.Message);
          console.log(errors);
          if (errors["2901"] !== null && errors["2901"] !== undefined) {
            for (const row of errors["2901"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2901_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2902"] !== null && errors["2902"] !== undefined) {
            for (const row of errors["2902"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2902_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2903"] !== null && errors["2903"] !== undefined) {
            for (const row of errors["2903"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2903_{0}", [
                  row.toString(),
                ])
              );
            }
          }
        } else if (error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 2904) {
            this.errors.push(
                this.$t("components.errorhandler.error409_2904")
              );
        } else {
          this.error = error;
        }

      }
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.content /deep/ .v-card__title {
  display: none;
}
</style>
